import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'survey/donation/previewReceipt';

/**
 * Renders the donation receipt using the draft message (backend fills sample donor/amount data).
 * The body must be the bare IRawRichTextContentState — a wrapped body binds to null and silently
 * previews the default copy; a null body previews the stored message.
 */
export function useDonationReceiptPreviewQuery({
	surveyId,
	confirmationMessage,
	enabled = true,
	impersonationContext,
}: {
	surveyId?: string;
	confirmationMessage?: Api.IRawRichTextContentState;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!surveyId,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<{ html: string }>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/donation/${surveyId}/previewReceipt`,
				}),
				'POST',
				confirmationMessage ?? null
			);
		},
		queryKey: [BASE_QUERY_KEY, surveyId, confirmationMessage],
		meta: {
			toastErrorMessage: 'Failed to load receipt preview',
		},
	});
}
